const regeXs = {
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d| 2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]| 4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/,
  code: /^\d*$/,
}

export const isVerificateCode = (value) => regeXs.code.test(value);

const getErrorMessage = (validator) => {
  switch (validator) {
    case 'isRequired':
      return 'Field is required'
    case 'isEmail':
      return 'Invalid email format'
    case 'isPhone':
      return 'Please, provide valid phone number'
    default:
      return 'This field has errors'
  }
}

const validateField = (value, validators) => {
  let errors = ''

  validators.forEach((validator) => {
    switch (validator) {
      case 'isEmail':
        if (!regeXs.email.test(value)) {
          errors = getErrorMessage(validator)
        }
        break;
      case 'isPhone':
        if (!regeXs.phone.test(value)) {
          errors = getErrorMessage(validator)
        }
        break;
      case 'isRequired':
        if (!(value || '').trim()) {
          errors = getErrorMessage(validator)
        }
        break;
      default:
        break;
    }
  });

  return errors
}

export default (fields) => {
  const errors = {}

  fields.forEach((item, key) => {
    if (!item.validators) {
      return false
    }

    let error = validateField(item.value.trim(), item.validators)

    if (error) {
      errors[item.name] = error
    }
  })

  return errors
}



// WEBPACK FOOTER //
// ./src/utils/validate.js